//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DetailsHeader from '@/components/common_detailsHeader'
import PageBtns from "@/components/common_pageBtns.vue";
import MyForm from '@/components/common_form.vue'
import FlexTable from '@/components/common_flexTable.vue'
export default {
  name: '',
  components: { DetailsHeader, PageBtns, MyForm, FlexTable },
  data () {
    return {
      headerConfig: {
        title: {text: 'SI1903182004063892'},
        desc: {text: '订单状态：处理完毕'}
      },
      formConfig1: {fontSize:'14px', list:[
        { type: 'input', title: '单据类型', placeholder: '请输入订单号', no_arrow: true },
        { type: 'input', title: '创建方式', placeholder: '请输入订单号', no_arrow: true },
        { type: 'input', title: '制单时间', placeholder: '请输入订单号', no_arrow: true },
        { type: 'input', title: '扫码数量', placeholder: '请输入订单号', no_arrow: true },
        { type: 'input', title: '异常数量', placeholder: '请输入订单号', no_arrow: true },
        { type: 'input', title: '产品数量', placeholder: '请输入订单号', no_arrow: true },
        { type: 'html', title: '扫码数据', 
          html: '<a class="common-link">点击查看</a>[注：用于比对原始扫码数据]', no_arrow: true },
      ]},
      formConfig2: {fontSize:'14px', list:[
        { type: 'input', title: '门店名称', placeholder: '请输入订单号', no_arrow: true },
        { type: 'input', title: '扫码人', placeholder: '请输入订单号', no_arrow: true },
        { type: 'input', title: '扫码时间', placeholder: '请输入订单号', no_arrow: true },
      ]},
      formConfig3: {fontSize:'14px', list:[
        { type: 'input', title: '核算状态', placeholder: '请输入订单号', no_arrow: true },
        { type: 'input', title: '核算时间', placeholder: '请输入订单号', no_arrow: true },
      ]},
      tableConfig: {
        thList: [
          {text: '序号', width: '15%'},
          {text: '扫码序列', flex: '1'},
          {text: '扫码类型', width: '20%'},
        ],
        trList: [
          ['1.[P0886]朵拉小羊幼儿配方羊奶粉800g×6罐'],
          [1, {isHtml:true, html:'<p>0062*************177 <a class="common-link">查看单品码</a></p>'}, '单品码'],
          [2, {isHtml:true, html:'<p>0062*************071 <a class="common-link">查看单品码</a></p>'}, '单品码'],
          [3, {isHtml:true, html:'<p>0062*************058 <a class="common-link">查看单品码</a></p>'}, '单品码'],
          [4, {isHtml:true, html:'<p>0062*************244 <a class="common-link">查看单品码</a></p>'}, '单品码'],
          [5, {isHtml:true, html:'<p>0062*************197 <a class="common-link">查看单品码</a></p>'}, '单品码'],
        ]
      },
      btnConfig: {
        list: [ {text:'返回', type: 'primary', action: () => this.$router.go(-1) } ],
      },
    }
  },
  props: [],
  computed: {},
  created () {},
  methods: {}
}
